import { Controller } from "stimulus"
import Rails from "@rails/ujs"

const axios = require('axios')

export default class extends Controller {

  static targets=["total", "additionalTable", "addMemberBox","autoChk","costId", "checkValid",
                  "form",  "addTitle", "addFirstname", "addLastname", "addEmail", "assocBody", "addButton","spinner",
                  "errorMsg", "payerDetails", "paidAmount", "fieldsetA", "fieldsetB","donation","canHaveAdditional",
                  "renewal", "existingAdditional","optionalFields","hideDetailsButton", "hasAdditional",
                  "additionalTableBody","additionalMembersBox","addMembersErrors", "addCost", "addMax",
                  "existingAddMembers","removeAddMembers", "currentAddMembers",
                  "mainTitle", "mainFirstname", "mainLastname", "mainPhone", "mainAddress1", "mainAddress2",
                  "mainAddress3", "mainCity", "mainCounty", "mainCountry", "mainPostcode", "mainEmail"
                   ]

    connect(){

      axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      axios.defaults.headers.post['Content-Type'] = 'application/json';
      axios.defaults.headers['Accept'] = 'application/json';
      this.currentCost = 0
      this.additionalCost = 0
      this.currentTotal = 0
      this.donation = 0
      this.addMembers = 0
      this.maxMembers = 0
      this.planID = ""
      this.singlePlanID = ""
      this.paypal_hash = {}
      this.setPayPalHash(this.planID)
      this.idsToKeep = []
      this.idsToRemove = []
      this.clientId = this.data.get("client-id")
      this.quantity = 1
      if(this.renewalTarget.value == "true" && this.data.get("giftaid") == "YES")
      {
        this.fieldsetBTarget.classList.add("d-none")
      }
      this.refresh()
      this.logToPage("starting new subscription")
      this.logToPage(navigator.userAgent)
    }

    valid(){
      var check = this.data.get("valid")
      if (check == 'true')
      {
        return true
      }
      else
      {
        return false
      }
    }

    refresh(){
      let that=this
      setTimeout(function(){that.openAddBox()},1000)
      if(this.costIdTarget.value != "") {
        setTimeout(function () {
          var elem = document.querySelector(`[data-cost-id='${that.costIdTarget.value}']`)
          var ev = new Event('click')
          elem.dispatchEvent(ev)
          let currentMembers =(that.currentAddMembersTarget.dataset["members"])
          if(currentMembers)
          {
             that.addMembers = 0 // reset as adding again
             var current = JSON.parse(currentMembers)
             for(var key in current){
                 let member = current[key]
                 that.addMemberToPage(member)
             }
          }
           if(that.idsToKeep[0])
           {
              that.addMembers = 0

           }
        }, 500)

      }

    }


    setCostId(e){
      let cid = e.target.dataset.costId
      this.currentCost = parseFloat(e.target.dataset.cost)
      this.additionalCost = parseFloat(e.target.dataset.addCost)
      this.planID = e.target.dataset.planId
      this.singlePlanID = e.target.dataset.singlePlanId
      this.setPayPalHash()
      this.costIdTarget.value = cid
      this.highlightRow(e.target)
      this.updateTotals()
      this.errorMsgTarget.classList.add("d-none")
      this.maxMembers = parseInt(e.target.dataset.canAdd) - 1
      this.addMaxTarget.innerHTML= this.maxMembers.toString()
      if(this.maxMembers == 0)
      {
        let ev = new Event("click")
        Array.from(this.additionalTableBodyTarget.querySelectorAll("tr td button")).forEach(function(btn){
          btn.dispatchEvent(ev)
        })
      }
      if(this.addMembers >= this.maxMembers || this.maxMembers == 0)
      {
       this.canHaveAdditionalTarget.classList.add("d-none")
      }
      else
      {
        this.canHaveAdditionalTarget.classList.remove("d-none")
      }
      this.updateTotals()
    }

    setPayPalHash() {
      let that = this
      if (this.autoRenew) {
        var plan2use = that.planID
      } else {
        var plan2use = that.singlePlanID
      }

      this.paypal_hash = {
        'plan_id': plan2use, //needs to be the membership_level_cost's actual plan id
        'quantity': 1 + this.addMembers, // Creates the subscription
        'subscriber': {
          'name': {
            'given_name': that.mainFirstnameTarget.value,
            'surname': that.mainLastnameTarget.value
          },
          'email_address': this.mainEmailTarget.value,
          "shipping_address": {
            "name": {
              "full_name": this.mainFirstnameTarget.value + " " + this.mainLastnameTarget.value
            },
            "address": {
              "address_line_1": this.mainAddress1Target.value,
              "address_line_2": this.mainAddress2Target.value,
              "admin_area_1": this.mainCountyTarget.value,
              "admin_area_2": this.mainCityTarget.value,
              "postal_code": this.mainPostcodeTarget.value,
              "country_code": this.mainCountryTarget.value
            }
          }
        },
      }
      window.paypal_hash = this.paypal_hash
    }

    highlightRow(btn){
      Array.from(document.querySelectorAll("table#levels_table button")).forEach(function(b){
        if(b.classList.contains("btn-primary"))
        {}
        else
        {
          b.classList.remove("btn-warning")
          b.classList.add("btn-primary")
        }
      })
      Array.from(document.querySelectorAll("table#levels_table tbody tr")).forEach(function(row){
        if(row.classList.contains("green-row"))
        {
          row.classList.remove("green-row")
        }
        else
        {

        }
      })
      btn.classList.remove("btn-primary")
      btn.classList.add("btn-warning")
      btn.parentNode.parentNode.parentNode.classList.add("green-row")
    }

    setAutoRenew(e){
        this.autoRenew = e.target.checked
        this.setPayPalHash()
    }

    openAddBox(){
      if(this.maxMembers > 0)
      {
          this.canHaveAdditionalTarget.classList.remove("d-none")
          //this.addMemberBoxTarget.classList.remove("d-none")
          // this.addButtonTarget.classList.remove("btn-primary")
          // this.addButtonTarget.classList.add("btn-secondary")
          // this.addButtonTarget.innerHTML="Remove Household Member"
          this.hasAdditional = true
          this.hasAdditionalTarget.value = 'true'

      }
      else
      {
        //this.removeAdditional()
      }
      if(this.renewalTarget.value == "true")
      {
        let that=this
        let exists =  Array.from(this.additionalTableBodyTarget.querySelectorAll("tr.for-additional"))
        exists.forEach(function(row){
          that.idsToKeep.push(row.dataset.id)
          that.addMembers += 1
        })

        this.existingAddMembersTarget.value = this.idsToKeep.join(",")
        this.hideDetailsButtonTarget.classList.remove("d-none")

        if( this.valid())
        {
          this.optionalFieldsTarget.classList.add("d-none")
        }

      }
      this.checkAdded()
      this.updateTotals()
    }

    addMember(){
      let that = this
      let member = {
        title: this.addTitleTarget.value,
        firstname: this.addFirstnameTarget.value,
        lastname: this.addLastnameTarget.value,
        email: this.addEmailTarget.value
      }
      axios.get("/subscriptions/validate_additional", {
        params:{
          member: member,
          email: that.mainEmailTarget.value
        }
      }).then(function(result){
        if(result.data.result === true)
        {
          that.addMemberToPage(member)
        }
        else
        {
          that.addMembersErrorsTarget.innerHTML = result.data.messages
          that.addMembersErrorsTarget.classList.remove("d-none")
          if(result.data.errors.title)
          {
            that.addTitleTarget.classList.add("is-invalid")
          }
          else
          {
            that.addTitleTarget.classList.remove("is-invalid")
          }
          if(result.data.errors.firstname)
          {
            that.addFirstnameTarget.classList.add("is-invalid")
          }
          else
          {
            that.addFirstnameTarget.classList.remove("is-invalid")
          }
          if(result.data.errors.lastname)
          {
            that.addLastnameTarget.classList.add("is-invalid")
          }
          else
          {
            that.addLastnameTarget.classList.remove("is-invalid")
          }
          if(result.data.errors.email)
          {
            that.addEmailTarget.classList.add("is-invalid")
          }
          else
          {
            that.addEmailTarget.classList.remove("is-invalid")
          }
        }
      })

    }

    addMemberToPage(member){
      let token = Date.now().toString()
      let new_row = this.additionalMemberRow(member, token )
      this.additionalTableBodyTarget.insertAdjacentHTML("beforeend", new_row)
      let fields = this.additionalMemberFields(member,token)
      this.additionalMembersBoxTarget.insertAdjacentHTML("beforeend", fields)
      this.clearAdditionalFields()
      this.addMembersErrorsTarget.classList.add("d-none")
      this.addMembersErrorsTarget.innerHTML=""
      this.addMembers+=1
      this.checkAdded()
      this.updateTotals()
    }

    removeAdditional(e){
      let token = e.target.dataset.id
      let isExisting = e.target.dataset.existing
      let trow = this.additionalTableBodyTarget.querySelector(`tr[data-id='${token}']`)
      trow.remove()

      if(isExisting)
      {
        if(this.idsToKeep.includes(token))
        {
          this.idsToKeep.splice(this.idsToKeep.indexOf(token), 2)
          this.idsToRemove.push(token)
          this.existingAddMembersTarget.value = this.idsToKeep.join(",")
          this.removeAddMembersTarget.value = this.idsToRemove.join(",")
        }
      }
      else
      {
        let div = this.additionalMembersBoxTarget.querySelector(`div[data-id='${token}']`)
        div.remove()
      }

      this.addMembers -= 1

      this.updateTotals()
      this.checkAdded()
    }

    checkAdded(){
      //console.log(this.addMembers, this.maxMembers)
      if(this.addMembers > 0 && this.addMembers >= this.maxMembers)
      {
        this.addMemberBoxTarget.classList.add("d-none")
      }
      else
      {
        this.addMemberBoxTarget.classList.remove("d-none")
      }
    }

    unattachAdded(){
      // this.addMemberBoxTarget.classList.remove("d-none")
      // this.showExistingAddTarget.classList.add("d-none")
      // this.canHaveAdditionalTarget.classList.remove('d-none')
      // this.existingAdditionalTarget.value = 'false'
      // this.removeAdditional()
      // this.updateTotals()
    }

    restoreAdditional(){
      // this.addMemberBoxTarget.classList.add("d-none")
      // this.showAdditional()
      // this.existingAdditionalTarget.value = 'true'
      // this.hasAdditional = true
      // this.updateTotals()
    }

    clearAdditionalFields(){
      let inputs = Array.from(this.addMemberBoxTarget.querySelectorAll("input"))
      inputs.forEach(function(inp){
        inp.value=""
        inp.classList.remove("is-invalid")
      })
    }

    showAdditional(){
      console.log("showing")
      //this.showExistingAddTarget.classList.remove("d-none")
      this.canHaveAdditionalTarget.classList.add('d-none')
    }

    showDetails(e){
      if(this.optionalFieldsTarget.classList.contains("d-none"))
      {
        e.target.innerHTML = "Hide Profile Details"
        this.optionalFieldsTarget.classList.remove("d-none")
      }
      else
      {
        e.target.innerHTML = "Edit Profile Details"
        this.optionalFieldsTarget.classList.add("d-none")
      }
    }

    updateTotals(){
      let total = this.currentCost
      if(this.addMembers > 0)
      {
        total = total + this.additionalCost * this.addMembers
      }
      this.currentTotal = total
      this.totalTargets.forEach(function(t){
        t.innerHTML = total.toFixed(2)
      })
     this.addCostTarget.innerHTML = this.additionalCost.toFixed(2)
    }

    clearForm(){
     this.firstnameTarget.value = ""
     this.lastnameTarget.value=""
     this.emailTarget.value=""
    }

    selectButtonHTML(mid){
    let out =   `
       <button type="button" name="button" class="btn-select" data-mid="${mid}" data-action="click->payments#changeLevel">Select</button>
      `
      return out
    }

    additionalMemberRow(member,token){

     let out =  `
      <tr data-id=${token}>
      <td>${member.title}</td>
      <td>${member.firstname}</td>
      <td>${member.lastname}</td>
      <td>${member.email}</td>
      <td>
        <button data-action="payments#removeAdditional" data-id=${token} class="btn btn-sm btn-danger type="button" name="button">Remove</button>
      </td>
      </tr>
     `
     return out
    }

    additionalMemberFields(member,token){
      let out = `
      <div data-id=${token}>
      <input type="hidden" name="user_registration[members][${token}][title]" value="${member.title}"/>
      <input type="hidden" name="user_registration[members][${token}][firstname]" value="${member.firstname}"/>
      <input type="hidden" name="user_registration[members][${token}][lastname]" value="${member.lastname}"/>
      <input type="hidden" name="user_registration[members][${token}][email]" value="${member.email}"/>
      </div>
      `
      return out
    }

    cancelButton(){
      let btn=`
          <button data-action="click->payments#cancelToEdit" class="btn btn-danger float-right">Cancel payment and continue editting</button>
      `
      let target = document.getElementById("paypal-btn")
      target.insertAdjacentHTML("beforebegin", btn)

    }

    cancelToEdit(e){
      this.checkValidTarget.value="refresh"
      e.preventDefault()
      e.stopPropagation()
      Rails.fire(this.formTarget, 'submit');
    }

    payNow(e){
      e.preventDefault()
      e.stopPropagation()
      this.setPayPalHash()
      Rails.fire(this.formTarget, 'submit');
    }

    startPayment(){
      Array.from(this.fieldsetATarget.querySelectorAll("input")).forEach(function(i){
        i.readOnly = true
      })
      Array.from(this.fieldsetBTarget.querySelectorAll("input")).forEach(function(i){
        i.readOnly = true
      })

      this.setSpinner()
      let that = this
      this.loadPaypal()
      setTimeout(function(){
        that.renderIfCan()
      }, 300)

    }

    success(){
      var email = this.mainEmailTarget.value
      this.logToPage("Success fired - " + email)
      this.checkValidTarget.value="false"
      this.logToPage("check valid now false - " + email)
      this.sendBeacon()
      Rails.fire(this.formTarget, 'submit');
      //hopefully never get here
      this.logToPage("Rails.fire 'submit' called - " + email)
    }

    sendBeacon(){
      var data = new FormData();        
      var logData = document.getElementById("payment-messages").value;
      var token = document.getElementById("logging-token").value;
      data.append("msgs", logData);
      data.append("token",token );
      var param = document.querySelector("meta[name=csrf-param]").getAttribute("content");
      var csrf = document.querySelector("meta[name=csrf-token]").getAttribute("content");
      data.append(param, csrf)
      navigator.sendBeacon('/homes/logger', data);
    }

    setSpinner(){
      this.spinnerTarget.classList.remove("d-none")
      this.spinnerTarget.classList.add("loader")
    }

    renderIfCan(){
      let that = this
      if(window.paypal)
      {
        this.renderPaypal()
        this.cancelButton()
      }
      else
      {
        setTimeout(function(){
          that.renderIfCan()
        }, 300)
      }
    }

    renderPaypal(){
        this.renderPaypalRecurring()
    }

    renderPaypalRecurring(){

      let target = document.getElementById("paypal-btn")
      let that = this
      var quantity
      this.paidAmountTarget.value = this.currentTotal.toFixed(2)
      if(this.hasAdditional)
      {
        quantity= (this.addMembers + 1).toString()
      }
      else
      {
        quantity="1"
      }
      target.innerHTML = ""
      paypal.Buttons({
      createSubscription: function(data, actions) {
        return actions.subscription.create(that.paypal_hash)
      },
      onApprove: function(details, actions) {
        console.log(details)
        that.logToPage("Payment approved - " + that.mainEmailTarget.value)
        window.pp_details = details
        var pid = document.getElementById("user_registration_paypal_subscription_id")
        pid.value = details.subscriptionID
        that.payerDetailsTarget.value = JSON.stringify(details)
        var success = new CustomEvent("successfulPayment")
        document.dispatchEvent(success)
      },
      onError: function(details){
        console.log(details)        
        that.logToPage("Payment FAILED - " + that.mainEmailTarget.value + " - " + details.message)
        alert("Sorry payment failed, you could try again or email membership@ndfhs.org.uk for help")
      }
    }).render('#paypal-btn');
    }

    logToPage(msg){
      var logger = document.getElementById("payment-messages")
      if(logger.value == ""){
        logger.value = msg
      }
      else{
        logger.value = logger.value + ", " + msg
      }      
    }

    loadPaypal(){
      let tag = document.createElement("script")
      tag.src = this.subscriptionsApi()
      document.body.append(tag)
    }
    subscriptionsApi(){
      return "https://www.paypal.com/sdk/js?client-id=" + this.clientId + "&components=buttons&currency=GBP&vault=true&intent=subscription"
    }
  }
